import { SAFETY_POLICY_LABELS, useSafetyPolicies } from "@/api/safety-policies";
import { FormField, FormItem, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

type TriggerPolicyFormFieldsProps = {
  form: any;
  disabled?: boolean;
};

export const TriggerPolicyFormFields = ({ form, disabled }: TriggerPolicyFormFieldsProps) => {
  const { data: policies = [] } = useSafetyPolicies();

  return (
    <FormField
      control={form.control}
      name="policyId"
      render={({ field }) => (
        <FormItem className="space-y-3">
          <Select value={field.value || undefined} onValueChange={field.onChange} disabled={disabled}>
            <SelectTrigger className="h-9 text-sm">
              <SelectValue placeholder="Select a policy" />
            </SelectTrigger>
            <SelectContent>
              {policies.map((policy) => (
                <SelectItem key={policy.id} value={policy.id}>
                  {SAFETY_POLICY_LABELS[policy.type]}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
